import { IPhongBanActionTypes } from "../../action-types/category/IPhongBanActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IPhongBanReducer } from "../../reducer-model/category/IPhongBanReducer";

const initState: IPhongBanReducer = {
  status: eReducerStatusBase.is_not_initialization,
  phongBans: [],
};
export const phongBanReducer = (
  state: IPhongBanReducer = initState,
  action: IPhongBanActionTypes
): IPhongBanReducer => {
  switch (action.type) {
    case "PHONG_BAN_LOAD_START":
      return { ...state, status: eReducerStatusBase.is_loading };
    case "PHONG_BAN_LOAD_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_completed, phongBans: action.payload };
    case "PHONG_BAN_LOAD_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_BAN_SHOW_EDIT_MODAL":
      return { ...state, isShowEditModal: true, phongBanEditing: action.payload };
    case "PHONG_BAN_CLOSE_EDIT_MODAL":
      return { ...state, isShowEditModal: false };
    case "PHONG_BAN_SAVE_START":
      return { ...state, status: eReducerStatusBase.is_saving };
    case "PHONG_BAN_SAVE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload, isShowEditModal: false };
    case "PHONG_BAN_SAVE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    case "PHONG_BAN_DELETE_START":
      return { ...state, status: eReducerStatusBase.is_deleting };
    case "PHONG_BAN_DELETE_SUCCESS":
      return { ...state, status: eReducerStatusBase.is_need_reload };
    case "PHONG_BAN_DELETE_ERRR":
      return { ...state, status: eReducerStatusBase.is_completed };
    default:
      return state;
  }
};
